
<div class="notify-chip__border"></div>
<div class="notify-chip__content">
 <ng-content />
</div>

@if (isCloseable()) {
	<button
			type="button"
			class="notify-chip__close-button"
			mat-icon-button
			(click)="closeToast()"
			aria-label="Toast schließen">
			<ogs-m3-icon prefix="fal" icon="xmark"/>
	</button>
}
